import React from "react";
import { Row, Col, Table } from "react-bootstrap";

export default function PODetailsTab({ order, items }) {
  if (!order) return null;

  const subtotal = items.reduce((sum, it) => sum + (it.orderedQuantity * it.rate), 0);
  const taxAmount = subtotal * ((parseFloat(order.tax) || 0) / 100);
  const grandTotal = subtotal + taxAmount;

  return (
    <>
      <Row className="mb-3">
        <Col md={6}>
          <p><strong>Order Date:</strong> {new Date(order.orderDate).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          })}</p>
          <p><strong>Expected Delivery:</strong> {new Date(order.expectedDeliveryDate).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          })}</p>
          <p><strong>Delivery From:</strong> {order.deliveryFrom}</p>
        </Col>
        <Col md={6}>
          <p><strong>Delivery To:</strong> {order.deliveryTo}</p>
          <p><strong>Payment Terms:</strong> {order.paymentTerm}</p>
          <p><strong>Notes:</strong> {order.notes}</p>
        </Col>
      </Row>

      <h6 className="mt-4">Ordered Items</h6>
      <Table bordered responsive>
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Product</th>
            <th>Quality</th>
            <th>Qty</th>
            <th>Unit Price (₹)</th>
            <th>Total (₹)</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it, idx) => (
            <tr key={idx}>
              <td>{idx + 1}</td>
              <td>{it.productId?.productName}</td>
              <td>{it.quality}</td>
              <td>{it.orderedQuantity} {it.unit}</td>
              <td>{it.rate}</td>
              <td>{(it.orderedQuantity * it.rate).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <div className="text-end">
        <p>Subtotal: ₹{subtotal.toFixed(2)}</p>
        <p>Tax ({order.tax || 0}%): ₹{taxAmount.toFixed(2)}</p>
        <h5>Grand Total: ₹{grandTotal.toFixed(2)}</h5>
      </div>
    </>
  );
}
